export enum SIZE {
  SMALL = "small",
  MEDIUM = "medium",
  LARGE = "large",
}

export const heights = {
  [SIZE.SMALL]: 434,
  [SIZE.MEDIUM]: 474,
  [SIZE.LARGE]: 514,
};

export const widths = {
  [SIZE.SMALL]: 200,
  [SIZE.MEDIUM]: 240,
  [SIZE.LARGE]: 280,
};

export const sanitizeColor = (value: string) => {
  return value.replace("#", "");
};

export const contentClipboard = (
  src: string,
  width: string,
  height: string
) => `
  <div style="width:${width};text-align:center">
    <iframe
      src="${src}"
      frameborder="0"
      width="${width}"
      height="${height}"
    ></iframe>
    <div>
  </div>
`;
